//测试地址53
//  let base = "http://192.168.1.53:8899";
//测试地址53公网
// let base = 'http://58.247.123.22:81/api';
// 正式环境
let base = 'https://api.jhscale.net';
// 测控地址120
// let base = 'http://192.168.101.120:8899';

let path = {
  base: base + "",
  login: '/ysscale/web/agent/login/login',// 登录
  getAgentInfo: '/ysscale/web/agent/main/getAgentInfo', // 获取用户信息
  getLanguageAndTimezone: '/assist/i18n/getLanguageAndTimezone', // 获取国家列表
  getMsgCode: '/ysscale/web/agent/login/getMsgCode', // 获取验证码
  getMsgLoginCode: '/ysscale/web/agent/login/getMsgLoginCode',// 验证码登录
  editPwd:'/ysscale/web/agent/login/editPwd',//旧密码修改密码

    refreshCacheUrl:  '/ysscale/web/store/flushStoreBalance',//刷新缓存

// 经销商 --设备管理
  agentGetAgentSendCmdPageList: '/ysscale/web/agent/send/cmd/getAgentSendCmdPageList', // 获取用户信息
  agentGetCmdList: '/ysscale/cmd/list', // 常用指令列表
  agentSendAgentCmd: '/ysscale/web/agent/send/cmd/sendAgentCmd', // 经销商发送命令

  //经销商后台管理系统
  ysscaleBack_getAgentInfo: '/ysscale/web/agent/main/getAgentInfo', //获取用户信息
  ysscaleBack_perfectInfo: '/ysscale/web/agent/main/perfectInfo', //修改用户
  ysscaleBack_queryUserMoney: '/ysscale/web/bmikece/queryUserMoney', //查询用户余额明细
  ysscaleBack_applyDestoonFinanceCash: '/ysscale/web/bmikece/applyDestoonFinanceCash', //用户余额提现申请服务
  ysscaleBack_submission: '/ysscale/web/agent/main/submission', //提交审核
  ysscaleBack_findUserWithdrawPage: '/ysscale/web/bmikece/findUserWithdrawPage',//用户余额申请提现记录查询
  ysscaleBack_findAgentUserPage: '/ysscale/web/bingding/findAgentUserPage', //经销商关联商户信息
  ysscaleBack_perfectUserInfo: '/ysscale/web/agent/main/perfectUserInfo', //修改商户实名认证信息

  ysscaleBack_userLogList: '/search/reportQuery/fingUserTradePage', //商户交易(app)
  ysscaleBack_userLogLists: '/search/reportQuery/fingUserTradeStartPage',//分页查询商户日志日报表信息（web）

  ysscaleBack_findUserInfo: '/ysscale/web/bingding/queryUserInfo', // 查询商户信息
  ysscaleBack_linkUserAndAgentByAgent: '/ysscale/web/bingding/linkUserAndAgentByAgent', // 经销商自助关联
  ysscaleBack_agentApplyForUnBindingDevice: '/ysscale/web/agent/balance/agentApplyForUnBindingDevice', //经销商申请解绑设备
  ysscaleBack_agentUnBindingDevice: '/ysscale/web/agent/balance/agentUnBindingDevice', //经销商解绑设备
  ysscaleBack_findRebateRecord: '/search/rebateQuery/findRebateRecordByPersonPage',// 分佣信息查询（经销商）
  ysscaleBack_findBaseMaidReport: '/search/rebateQuery/findBaseMaidReportPage',//商户分佣信息查询（经销商）
  agentApplyForUnBindingDeviceList: '/ysscale/web/agent/balance/agentApplyForUnBindingDeviceList',
  File_Download_Url: '/server-file/fastdfs/download?path=', //图片访问路径
  county: '/assist/i18n/getLanguageAndTimezone', //国家
  getLoginCode: '/ysscale/web/agent/login/getMsgCode', // 获取手机登陆验证码
  register: '/ysscale/web/agent/login/register', //注册
  passwordReset: '/ysscale/web/agent/login/resetPwd', //密码重置
  getMsgRestCode: '/ysscale/web/agent/login/getMsgRestCode',

  findAgentUserPageV2: '/ysscale/web/bingding/findAgentUserPageV2',//经销商分页查询商户
  cloudFileExport: '/migration/find-index-mongo/cloudFileExport', // 云支付报表导出
  logFileExport: '/migration/find-index-mongo/logFileExport', // 日志报表明细导出
  getPageApplyExport: '/migration/find-index-mongo/getPageApplyExport',//云支付报表导出记录列表
  userLogExport: '/mosquare/logExport/userLogExport',//商户日志统计导出
  deviceLogExport: "/mosquare/logExport/deviceLogExport", // 设备日志统计导出CSV文件 device_log_export
  storeLogExport: base + "/mosquare/logExport/storeLogExport", // 店铺日志统计导出CSV文件 store_log_export
  deviceBillExport: base + "/mosquare/billExport/deviceBillExport", // 设备云支付报表统计导出CSV文件 device_bill_export
  storeBillExport: base + "/mosquare/billExport/storeBillExport", // 店铺云支付报表统计导出CSV文件 store_bill_export
  userBillExport: '/mosquare/billExport/userBillExport',//商户云支付导出
  theSameDayLogQuery: "/search/logSearchMaster/theSameDayLogQuery",//日志当日报表查询（平台）
  theSameDayBillQuery: "/search/billSearchMaster/theSameDayBillQuery",//云支付当日报表查询（平台）
  logQueryStartPage: "/search/logSearchMaster/logQueryStartPage", //日志周月年报表查询（平台）
  logDetailedQueryPage: "/search/logSearchMaster/logDetailedQueryPage", //日志报表明细查询(平台)
  billQueryStartPage: "/search/billSearchMaster/billQueryStartPage", //云支付周月年报表查询（平台）
  billDetailQueryPage: "/search/billSearchMaster/billDetailQueryPage", //支付日志报表明细查询(平台)
  myShopList: "/ysscale/mobile/user/my/myShopList", //店铺
  deviceList: "/ysscale/mobile/user/device/deviceList", //设备
  maidReportFileDownload: '/mosquare/rebate/maidReportFiledownload',//生成经销商分佣金额统计CSV文件

  // bindMultipleAccount:'/push/account/bind-multiple-account',//多类型用户绑定公众号
  // signQueryPush:'/ysscale/push/sign-query-account',//sign查询指定推送
  savePush: '/ysscale/agentPush/savePush',//经销商绑定公众号
  bindMultipleAccount: '/ysscale/agentPush/listByAgent',//经销商查询绑定绑定关系

  exportBalanceAgent: '/mp/web/userBalance/exportBalanceAgent',//经销商 导出用户余额（欠费用户）
  queryStoreByUserId: "/ysscale/publicp/queryStoreByUserId",//商户Id获取店铺信息
  findStoreDetail: "/ysscale/web/store/findStoreDetail",//查询店铺详情
  queryPaymentStrategList: "/ysscale/web/payStrategy/queryPaymentStrategList",//查询支付策略
  changePaymentStrategy: "/ysscale/web/payStrategy/changePaymentStrategy",//变更支付策略
  findUserDetail: "/ysscale/web/user/findUserDetail",//商户详情
  updateUserDetail:'/ysscale/web/user/modifyUser',//修改商户信息
  updateShopDetail:'/ysscale/web/store/modifyStore',//修改店铺信息
  JHNChangeDeviceShop: "/ysscale/mobile/user/device/updateBalanceStore", // 更换设备店铺
  // 汽车衡
  truckGetdevice: '/ysscale/balance/truckScale/list',//获取商户设备列表

  truckGetMerchantRecordPage: base + '/search/record/getMerchantRecordPage', //商户查询事件信息
  truckScaleList: base + '/ysscale/balance/truckScale/list', //客户查询设备列表 search=设备别名、设备标识
  truckScaleDetail: base + '/ysscale/balance/truckScale/get', // 设备详情
  truckScaleCount: base + '/ysscale/balance/truckScale/count', // 统计设备数量
  truckGetContent: base + '/scan/sweep/get-content',//换取实际绑定条码
  truckScanSuccess: base + '/scan/sweep/scan-success',//
  truckGetShop: base + '/ysscale/mobile/user/my/myShopList',// 我的店铺
  truckGetWeightTotal: base + '/search/record/getTruckRecordStatistics',//查询称重支付统计信息
  truckUnbindDeviceSendMsg: base + '/ysscale/mobile/user/device/unBindingDeviceSendMsg', // 解绑设备获取验证码
  truckUnbindDevice: base + '/ysscale/mobile/user/device/unBindingDevice', //解绑设备
  truckAgentLogin:base + '/ysscale/web/agent/login/login', //经销商登录
  truckGetAgentInfo:base + '/ysscale/web/agent/main/getAgentInfo', // 获取经销商信息
  //  websocket
  truckGetWebsocket: base + '/assist/server/getWebSocket/server-api-data',// 获取Websocket
  //云支付费率
  MERQueryAliWXPH: '/ysscale/web/param/queryAliWXPH', // 查询云支付费率
  MERAddAliWXPH: '/ysscale/web/param/addAliWXPH',//添加云支付费率


  // 模型管理
  getMerModelList: "/assist/pluImage/pageMerchantApply",//获取商户模型列表
  getMerKindTree: "/erp/bascis/plu/category/tree",//获取商户分类树
  getMerPLU: "/erp/bascis/plu/listPagePlu",//获取商户分类树

  getModelList: "/assist/pluImage/pageAgentApply", // 获取经销商模型列表
  getModelCenterList: "/assist/pluImage/pageOpenApply", // 获取中央商品库模型
  copyAIModel: "/assist/pluImage/saveShare", // 保存ai分享数据
  aiModelShare: "/assist/pluImage/shareAi", // ai分享
  getKindTree: "/assist/web/v2/kind/getKindTree", // 获取分类树
  getPLU: "/assist/web/v2/plu/listPageWithCount",// 分页查询PLU
  applyExportPluPictureByPlu: "/assist/pluImage/applyExportPluPictureByPlu",// 新增模型训练

//  公众号绑定
  queryUserPush: "/ysscale/push/query-user-push",// 获取用户公众号绑定信息
  bindPublicAccount: "/ysscale/mobile/user/my/bind-account",// 绑定公众号

//

  MERFindOtherCloudpayInfoPage: "/ysscale/web/user/findOtherCloudpayInfoPage", // 分页查询第三方支付信息
  MERGetUnionInfo: "/ysscale/web/union/get-union-info", // 查询商户、店铺支付渠道
  MERSetUnionInfo: "/ysscale/web/union/set-union-info", // 设置商户、店铺支付渠道

  //设置设备支付策略
  MERDeviceList: "/ysscale/web/store/store-balance-page", // 根据店铺获取设备
  MERFindStoreDetail: "/ysscale/web/store/findStoreDetail", // 获取店铺详情
  // ysscaleBack_findUserBalance: "/ysscale/web/user/findUserBalancePage", //   店主下的电子秤
  ysscaleBack_findUserBalance: "/ysscale/publicp/queryBalancePage", //店主下的电子秤

  //支付签约申请
  queryApplyInfoPage: "/ysscale/web/apply/queryApplyInfoPage", // 查询签约列表
  failApply: "/ysscale/web/apply/fail-apply", // 平台/第三方 审核失败 [第三方系统出问题审核失败了，人工介入填写第三方失败信息]
  successApply: "/ysscale/web/apply/success-apply", // 平台审核通过
  submitApply: "/ysscale/web/apply/submit-apply", // 平台提交第三方审核
  successApplyAndSubmitApply: "/ysscale//web/apply/success-apply-and-submit-apply", // 平台提交审核直接至第三方审核
  queryApply: "/ysscale/web/apply/query-apply", // 查询第三方审核结果
  updateSubId: "/ysscale/web/apply/update-subid", // 更新第三方签约子商户ID至用户/店铺表中
  saveUpdateApply: "/ysscale/mobile/user/apply/save-update-apply", // 暂存商户信息
  failUpdateApply: "/ysscale/mobile/user/apply/fail-update-apply", // 重新提交审核
  findAllStoreAuthPage: "/ysscale/web/store/findAllStoreAuthPage", // 查询商户授权信息

  tempApply: "/ysscale/web/apply/temp-apply", //平台待审核 内容数据 暂存
  // findAgentUserPageV2: "/ysscale/web/bingding/findAgentUserPageV2", //分页查询商户店铺(基本信息)


  //  第三方支付
  MERQueryOtherCloudpayInfo: "/ysscale/web/user/queryOtherCloudpayInfo", // 查询第三方支付列表
  MERAddUserCloudpayToken: "/ysscale/web/union/union-info", // 添加第三方支付
  MERUpdateUserCloudpayToken: "/ysscale/web/union/union-info", // 编辑第三方支付
  MERDelUnionInfo: "/ysscale//web/union/union-info", // 删除第三方支付
  MERTerminalActivation: "/interview/jh/pay/union2/activation", // 银联天满设备激活
  MERDelUserCloudpayToken: "/ysscale/web/user/delUserCloudpayToken", // 禁用第三方支付
  MERQueryPayment: "/interview/query/payment", // 云支付测试
  MERQueryPaymentQuery: "/interview/query/payment-query", // 查询支付信息
  MERChangePaymentStrategy: "/ysscale/web/payStrategy/changePaymentStrategy", // 更换支付策略

  MERSqbActivation:'/interview/jh/pay/sqb/activation', // 收钱吧激活
  MERSqbArrive:'/ysscale/web/union/sqb/sign-in',//收钱吧签到
  MERSqbArriveSingle:'/interview/jh/pay/sqb/signtion',//收钱吧签到
  MERRefreshUnionInfo:'/ysscale/web/union/refresh-union-info',//刷新银联支付信息

  listShopAll: "/ysscale/mobile/user/my/listShopAll", // 查询店铺列表
  // deviceList: "/ysscale/mobile/user/device/deviceList", // 查询设备列表
  querySuperAgentAuth: '/ysscale/web/agent/main/querySuperAgentAuth', // 查询经销商授权码列表
  delSuperAgentAuth: '/ysscale/web/agent/main/delSuperAgentAuth', // 删除经销商授权码列表
  addSuperAgentAuth: '/ysscale/web/agent/main/addSuperAgentAuth', // 添加经销商授权码

  getKindPageList: "/assist/web/v2/kind/getKindPageList", // 获取分类列表
  kindDelete: "/assist/web/v2/kind/delete", // 删除
  kindAdd: "/assist/web/v2/kind/saveKind", // 新增
  kindUpdate: "/assist/web/v2/kind/update", // 更新
  kindReorder: "/assist/web/v2/kind/kindReorder", // 排序
  getKindDetail: "/assist/web/v2/kind/detail", // 获取分类详情
  getKindPluList: "/assist/web/v2/plu/listPLU", // 获取种类对应plu列表
  getPluListV2: "/assist/web/v2/plu/pagePLU", //获取PLU列表数据
  getPlatFromParameterList: "/assist/web/v2/parameter/getPlatFromParameterList", //查询系统参数List列表
  pluEnable: "/assist/web/v2/plu/enable", // plu是否上架
  pluListEnable: "/assist/web/v2/plu/enablePluList", // plu批量上架
  getPLUInfo: "/assist/web/v2/plu/getPLUInfo", // 获取plu详情
  pluDelete: "/assist/web/v2/plu/deletePLU", // 删除plu
  pluListDelete: "/assist/web/v2/plu/deletePLUList", // 批量删除plu
  pluUpdate: "/assist/web/v2/plu/updatePLU", // 更新plu
  pluAdd: "/assist/web/v2/plu/savePLU", //新增plu
  saveBatchPLU: "/assist/web/v2/plu/saveBatchPLU", //新增PLU  批量
//     铅封
    listLeadSeal: '/socketService/lead_seal/listLeadSeal', //查询铅封
    getLeadSeal: '/socketService/lead_seal/getLeadSeal', //查询铅封详情
    updateLeadSeal: '/socketService/lead_seal/updateLeadSeal', //修改铅封
    updateLeadSealInfo: '/socketService/lead_seal/fullLeadSeal', //完善铅封信息==临时使用
    listSealStatus: '/socketService/lead_seal/listSealStatus', //历史状态
    getSealStatus: "/socketService/lead_seal/getSealStatus", //历史状态详情
  pageSealType:'/socketService/lead_seal/pageSealType',
};
export default path;



//////////////////
// WEBPACK FOOTER
// ./api/url.js
// module id = E5mJ
// module chunks = 28